<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="7"
      >
        <customer-seminar-card
          :information="information"
          :loading="loading"
        />
      </v-col>
      <v-col
        cols="12"
        md="5"
        class="text-end align-self-end"
      >
        <v-btn
          fill
          color="primary white--text"
          @click="downloadPDF"
        >
          {{ $t("course_report.pdf_download") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <customer-questionnaire-card
          :loading="loading"
          :questionnaires="processedQuestionnaire"
        />
      </v-col>
    </v-row>
    <VueHtml2pdf
      ref="download"
      :filename="pdfTitle"
      :enable-download="true"
      :show-layout="false"
      :manual-pagination="true"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-orientation="portrait"
    >
      <section
        slot="pdf-content"
        style="padding: 8px 12px;"
      >
        <v-row>
          <v-col
            cols="12"
          >
            <customer-seminar-card
              :information="information"
              :loading="loading"
            />
          </v-col>
          <v-col
            cols="12"
            style="padding-top: 8px"
          >
            <customer-questionnaire-card
              :loading="loading"
              :questionnaires="processedQuestionnaire"
            />
          </v-col>
        </v-row>
      </section>
    </VueHtml2pdf>
  </v-container>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import CustomerSeminarCard from './CustomerSeminarCard.vue'
import CustomerQuestionnaireCard from './CustomerQuestionnaireCard.vue'
import QUATSError from '../../../plugins/error'

export default {
  components: {
    CustomerQuestionnaireCard,
    CustomerSeminarCard,
    VueHtml2pdf
  },
  data () {
    return {
      information: {},
      loading: true,
    }
  },

  computed: {
    pdfTitle() {
      const info = this.information
      const questionType = info.fc_flg === 0 ? 'before_report' : 'after_report'
      return `${info.customer_id}_${info.seminar_id}_${questionType}`
    },

    processedQuestionnaire() {
      const questionnaire = this.information.quats_contents_json ? JSON.parse(this.information?.quats_contents_json) : {}
      const questionKeys = Object.keys(questionnaire).filter(key => questionnaire[key].question)
      return questionKeys.map(key => questionnaire[key])
    }
  },

  mounted() {
    this.loading = true
    const params = this.$route.params
    const data = `seminar_id=${params.seminar_id}&customer_id=${params.customer_id}&fc_flg=${params.fc_flg}`
    window.axios.get(`/api/employee-seminar-info/seminar/questionnaire?${data}`)
      .then(res => {
        this.information = res.data.data.data[0]
      }).catch(err => {
        this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
      }).finally(() => {
        this.loading = false
      })
  },

  methods: {
    downloadPDF() {
      this.$refs.download.generatePdf()
    },
  }
}
</script>

<style scoped>

</style>
